import stylesMain from "../../pages/Popup/popupList.module.css";
import styles from "./BulkReceipt.module.css";
import FilledButton from "../ReusableComponents/Buttons/FilledButton";
import Icon from "../../public/resources/icon/icon_success_popup.svg";
import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Modal from "react-bootstrap/Modal";
import AccountInfo from "./component/AccountInfo";

function BulkReceiptReact({
  text,
  Requestedmessage,
  clickButtonHandler,
  modalIsOpenBulk,
  reference,
  accountInfo,
  tableHeaderReceipt,
  tableContentReceipt,
  content,
  Requestedmessage2,
  Requestedmessage3
}) {
  const router = useRouter();

  const okIntershareHandler = () => {
    router.push("/CelcomAllShare");
  };
  return (
    <>
      {/* <div id="modal">
        <div
          className={`modal fade ${styles.scrollbar}`}
          id="bulkReceipt"
          tabIndex="-1"
        >
          <div
            className={`modal-dialog ${stylesMain.modalDialogBillingHist} ${styles.modalWidth}`}
          >
            <div className={`modal-content ${stylesMain.modalContent}`}>
              <div className={`modal-body ${stylesMain.modalBody}`}>
                <div className={`d-flex flex-column ${styles.head}`}>
                  <Icon className="mx-auto" />
                  <p>{text}</p>
                </div>
                <div className={styles.content}>
                  <p>{Requestedmessage}</p>
                  {refNoParents && (
                    <p>
                      Parents reference no:&nbsp;
                      <Link href="#" className={styles.textColor}>
                        {refNoParents}
                      </Link>
                    </p>
                  )}
                  {popup === "User" ? null : (
                    <p>
                      Reference No:&nbsp;
                      <span href="#" className={styles.textColor}>
                        {refNo}
                      </span>
                    </p>
                  )}
                  {
                    popup === "bulkChangeName" ? (
                      <p className="mb-0">
                        Navigate to Bulk{" "}
                        <a
                          className={styles.textColor}
                          onClick={() => {
                            $("#bulkReceipt").modal("hide");
                            $(".close").on();
                            $(".modal-backdrop").remove();
                            router.push("/support");
                          }}
                        >
                          SR Status
                        </a>{" "}
                        to check the status and search the reference number for
                        more details.
                      </p>
                    ) :
                      popup === "bulkChangeAddress" ? (
                        <p className="mb-0">
                          Navigate to Bulk{" "}
                          <a
                            className={styles.textColor}
                            onClick={() => {
                              $("#bulkReceipt").modal("hide");
                              $(".close").on();
                              $(".modal-backdrop").remove();
                              router.push("/support");
                            }}
                          >
                            SR Status
                          </a>{" "}
                          to check the status and search the reference number for
                          more details.
                        </p>
                      ) : (
                        <p className="mb-0">
                          Navigate to support page and search the reference number
                          for more details.
                        </p>
                      )}
                </div>

                <div className="text-end">
                  {popup === "InterShare" ? (
                    <FilledButton
                      name="OK"
                      dataDismiss="modal"
                      clickHandler={
                        // if (popup === "InterShare") setStepper(0);
                        okIntershareHandler
                      }
                    />
                  ) : popup === "BulkChangeBillMedia" ||
                    popup === "bulkChangeName" ? (
                    <FilledButton name="OK" clickHandler={clickButtonHandler} />
                  ) : (
                    <FilledButton
                      name="OK"
                      dataDismiss="modal"
                      clickHandler={clickButtonHandler}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Modal show={modalIsOpenBulk} dialogClassName={styles.modalWidthNew}>
        <Modal.Header>
        </Modal.Header>
        <Modal.Body>
          <div className={`d-flex flex-column ${styles.head}`}>
            <Icon className="mx-auto" />
            <p>{text}</p>
          </div>
          <div className="mb-3">{Requestedmessage}</div>

          {/* if you need this ref no - send props */}
          {reference && (
            <p>{reference.title}:&nbsp;
              <a className={styles.textColor}>{reference.number}</a>
            </p>
          )}

          {Requestedmessage2 &&
            <div className="mb-3">Navigate to support page for more details.</div>
          }
          {Requestedmessage3 &&
            <div className="mb-3">Please check within 2 hours.<br />For more info, please contact our Celcom Careline.<br /> 1111/+60196011111.</div>
          }

          {accountInfo &&
            <div className="mx-2">
              <AccountInfo
                label1="Account Name"
                value1={accountInfo.accountName}
                label2="Group"
                value2={accountInfo.group}
                label3="Role"
                value3={accountInfo.role}
              />
            </div>}

          {/* if you need this table - send props */}
          {tableHeaderReceipt && tableContentReceipt &&
            <div className={`d-flex flex-row mb-3 ${content?.length > 4 && styles.overflow}`}>
              <table className="table border rounded shadow-sm mb-0 mx-2">
                <thead className="thead-dark">
                  <tr>{tableHeaderReceipt}</tr>
                </thead>
                <tbody>{tableContentReceipt}</tbody>
              </table>
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <FilledButton name="OK" clickHandler={clickButtonHandler} />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BulkReceiptReact;
